import { render } from "./PotentialGeneralInfo.vue?vue&type=template&id=50728cf0&scoped=true&lang=pug"
import script from "./PotentialGeneralInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./PotentialGeneralInfo.vue?vue&type=script&setup=true&lang=js"

import "./PotentialGeneralInfo.vue?vue&type=style&index=0&id=50728cf0&scoped=true&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50728cf0"]])

export default __exports__